import { Input } from "@ember/component";
import DSaveControls from "discourse/ui-kit/d-save-controls";
import { i18n } from "discourse-i18n";

export default <template>
  <label class="control-label">{{i18n "discourse_rewind.title"}}</label>

  <div
    class="control-group rewind-setting"
    data-setting-name="user_discourse_rewind_enabled"
  >
    <label class="controls">
      <Input
        id="user_discourse_rewind_enabled"
        @checked={{@controller.model.user_option.discourse_rewind_enabled}}
        @type="checkbox"
      />
      {{i18n "discourse_rewind.preferences.enable_rewind"}}
    </label>
  </div>

  <div
    class="control-group rewind-setting"
    data-setting-name="user_discourse_rewind_share_publicly"
  >
    <label class="controls">
      <Input
        disabled={{@controller.model.user_option.hide_profile}}
        id="user_discourse_rewind_share_publicly"
        title={{i18n
          "discourse_rewind.preferences.cannot_share_when_profile_hidden"
        }}
        @checked={{@controller.model.user_option.discourse_rewind_share_publicly}}
        @type="checkbox"
      />
      {{i18n "discourse_rewind.preferences.share_publicly"}}
    </label>
  </div>

  <DSaveControls
    @action={{@controller.save}}
    @model={{@controller.model}}
    @saved={{@controller.saved}}
  />
</template>
